import React from "react";

import withStyles from "@material-ui/core/styles/withStyles";


import Divider from '@material-ui/core/Divider';
import Header from "components/Header/Header.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Card from "components/Card/Card.jsx";


import loginPageStyle from "assets/jss/material-kit-react/views/loginPage.jsx";

import image from "assets/img/ic.jpg";



class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden"
    };
  }
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }
  render() {
    const { classes, ...rest } = this.props;
    return (
      <div>
        <Header
          brand="MGEC" 
          rightLinks={<HeaderLinks />}
          fixed
          color="white"
          changeColorOnScroll={{
            height: 400,
            color: "white"
          }}
          {...rest}
        />
        <div
          className={classes.pageHeader}
          style={{
            backgroundImage: "url(" + image + ")",
            backgroundSize: "cover",
            backgroundPosition: "top center"
          }}
        >
          <div className={classes.container}>
            <GridContainer justify="center" >
              <GridItem xs={12} sm={12} md={4}>
              <Card className={classes[this.state.cardAnimaton]}>
                 <h2> 
                 Kyaung Kyo App for ILBC  
                  </h2>
                 <Divider />
                  <h4>
                  This App will be used by Parents of Students in ILBC school when they come to pick up their kids.When Start button is pressed, App will send location of parent to ILBC school server and School can monitor whether parent is approaching to school so that they can prepare appropriate arrangement for the kids to avoid traffic jam near school area. 
                  </h4>
              
</Card>
              </GridItem>
            </GridContainer>
          </div>
          <br />
          <br />
          <br />

         
        </div>
       
         <Footer/>
      </div>
    );
  }
}

export default withStyles(loginPageStyle)(LoginPage);



// WEBPACK FOOTER //
// ./src/views/ProjectPage/ProjectPage.jsx